const i = {
  code: "hi",
  facebook: "hi_IN",
  label: "हिंदी",
  loadingText: "लोड हो रहा है...",
  translations: {
    ar: "अरबी",
    de: "जर्मन",
    en: "अंग्रेज़ी",
    es: "स्पेनिश",
    fr: "फ़्रेंच",
    he: "हिब्रू",
    hi: "हिंदी",
    id: "इंडोनेशियाई",
    it: "इतालवी",
    ja: "जापानी",
    km: "खमेर",
    ko: "कोरियाई",
    lo: "लाओ",
    ms: "मलय",
    nl: "डच",
    pt: "पुर्तगाली",
    ru: "रूसी",
    th: "थाई",
    tl: "फिलीपीनो",
    tr: "तुर्की",
    vi: "वियतनामी",
    "zh-CN": "चीनी (सरलीकृत)",
    "zh-TW": "चीनी (पारंपरिक)"
  }
};
export {
  i as hindi
};
